<template>
  <q-page padding>
    <div class="row justify-center q-gutter-md q-pa-md">
      <div class="col-12 col-md-6 col-lg-3">
      <q-card :flat="$q.dark.mode">
        <q-card-section>
          <div class="text-h6">
            <q-avatar><q-icon name="sunny"/></q-avatar>Wetter
          </div>
          <TemperatureItem sensorId="laws" />
        </q-card-section>
      </q-card>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
      <q-card :flat="$q.dark.mode">
        <q-card-section>
          <div class="text-h6">
          <q-avatar><q-icon name="support"/></q-avatar>Nächste Termine
          </div>
          <q-list separator>
            <template v-if="loadingData">
              <q-item v-for="n in 3" :key="'skel-mission-' + n">
                <q-item-section>
                  <q-skeleton type="text" class="text-h6" />
                  <q-skeleton type="text" width="60%" />
                </q-item-section>
              </q-item>
            </template>
            <template v-if="!missions.length && !loadingData">
              <q-item dense>
                <q-item-section>
                  <q-item-label>Keine anstehenden Wachdienste.</q-item-label>
                </q-item-section>
              </q-item>
            </template>
            <template v-for="mission in missions" :key="mission" >
              <mission-list-item  :mission="mission" badges  />
            </template>
          </q-list>
        </q-card-section>
      </q-card>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
      <q-card :flat="$q.dark.mode">
        <q-card-section>
          <div class="text-h6">
            <q-avatar><q-icon name="swap_horiz"/></q-avatar>Tauschangebote
          </div>
          <q-list separator>
            <template v-if="loadingData">
              <q-item v-for="n in 2" :key="'skel-offer-' + n">
                <q-item-section>
                  <q-skeleton type="text" />
                  <q-skeleton type="text" width="40%" />
                </q-item-section>
              </q-item>
            </template>
            <template v-for="offer in offers" :key="offer" >
              <PositionOfferListItem  :pos="offer"/>
            </template>
            <q-item dense v-if="!offers.length">
              <q-item-section>
              <q-item-label>Momentan gibt es keine Tauschangebote.</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-card-section>
      </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
import { apiErrorHandler } from '@/utils/apiErrorHandler.js'
import { byDate } from '@/utils/useDateUtils.js'
import { useUserStore } from '@/stores/user.js'
import { getMissionsUpcoming } from '@/services/Missions.js'
import { getOfferedPositions } from '@/services/Teams.js'
import MissionListItem from '@/components/MissionListItem.vue'
import PositionOfferListItem from '@/components/PositionOfferListItem.vue'
import TemperatureItem from '@/components/TemperatureItem.vue'


export default {
  setup() {
    const userStore = useUserStore()
    return { userStore }
  },
  data() {
    return {
      missions: [],
      offers: [],
      loadingData: false
    }
  },
  components: {
    'mission-list-item': MissionListItem,
    PositionOfferListItem,
    TemperatureItem
    },
  mounted() {
    this.loadingData = true
    getMissionsUpcoming(5)
      .then(missions => { this.missions = missions.sort(byDate) })
      .catch(apiErrorHandler("[Dashboard] Missionen laden"))
    getOfferedPositions()
      .then(offers => { this.offers = offers })
      .catch(apiErrorHandler("[Dashboard] Tauschangebote laden"))
      .finally(() => { this.loadingData = false })
  },
  methods: {
  }
}
</script>

<style>
#title-block {
  height: 25vh;
  max-height: 300px;
}
</style>
